import AppBar from "@material-ui/core/AppBar";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import { green } from "@material-ui/core/colors";
import Fab from "@material-ui/core/Fab";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import AddIcon from "@material-ui/icons/Add";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ClearIcon from "@material-ui/icons/Clear";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import "font-awesome/css/font-awesome.min.css";
import React, { useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, Route, Switch, useRouteMatch } from "react-router-dom";
import { getEmployeeTravelData } from "../actions/getEmployeeTravelData";
import { loadBioDataMaster } from "../actions/loadBioDataMaster";
import { loadTravelLinkData } from "../actions/requestTravelLink";
import { IP } from "../config/IP";
import store from "../store/createStore";
import SelectionCombo from "./containers/SelectionCombo";
import "./Dashboard.css";
import EmployeeTravelProcessingScreen from "./EmployeeTravelProcessingScreen";
import { LeftSideScreen } from "./SideScreen";
import PrimarySearchAppBar from "./TopToolBar";

//import HomeEditingDoc from "./HomeEditingDoc";
//https://codepen.io/themustafaomar/pen/jLMPKm

//import HomeEditingDoc from "./HomeEditingDoc";
//https://codepen.io/themustafaomar/pen/jLMPKm

const useStyles = makeStyles((theme) => ({
	root: {
		"& > *": {
			margin: theme.spacing(1),
		},
		width: "100%",
		maxWidth: "100%",
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
		margin: "auto",
	},
	paper: {
		width: 200,
		height: 230,
		overflow: "auto",
	},
	fab: {
		position: "absolute",
		bottom: theme.spacing(2),
		right: theme.spacing(2),
	},
	extendedIcon: {
		marginRight: theme.spacing(1),
	},
}));
function not(a, b) {
	return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
	return a.filter((value) => b.indexOf(value) !== -1);
}

function StaffTravelScreen(props) {
	//console.log("IP.nodeServer=", IP.nodeServer + "api/getDocsAggregates");
	const refUserSelect = useRef(null);
	const notitifcationRef = useRef();
	const state = useSelector((state) => state);

	const [dense, setDense] = React.useState(false);
	const [secondary, setSecondary] = React.useState(false);

	let allUser = state.auth.user.allUser.filter((x) => x.status === 1);
	const classes = useStyles();
	const [checked, setChecked] = React.useState([]);
	const [checked2, setChecked2] = React.useState([]);
	const [left, setLeft] = React.useState([]);
	const [right, setRight] = React.useState([]);

	let leftChecked = intersection(checked, left);
	let rightChecked = intersection(checked, right);
	const handleToggle2 = (value) => () => {
		const currentIndex = checked.indexOf(value);
		const newChecked = [];

		if (currentIndex === -1) {
			newChecked.push(value);
		} else {
			newChecked.splice(currentIndex, 1);
		}

		setChecked(newChecked);
		setChecked2(newChecked);
	};

	const handleToggle = (value) => () => {
		const currentIndex = checked.indexOf(value);
		const newChecked = [...checked];

		if (currentIndex === -1) {
			newChecked.push(value);
		} else {
			newChecked.splice(currentIndex, 1);
		}

		setChecked(newChecked);
	};

	const handleAllRight = () => {
		setRight(right.concat(left));
		setLeft([]);
	};

	const handleCheckedRight = () => {
		setRight(right.concat(leftChecked));
		setLeft(not(left, leftChecked));
		setChecked(not(checked, leftChecked));
	};

	const handleCheckedLeft = () => {
		setLeft(left.concat(rightChecked));
		setRight(not(right, rightChecked));
		setChecked(not(checked, rightChecked));
	};

	const handleAllLeft = () => {
		setLeft(left.concat(right));
		setRight([]);
	};
	const customList2 = (items) => (
		<Paper className={classes.paper}>
			<List dense component="div" role="list">
				{items.map((value) => {
					const labelId = `transfer-list-item-${value.key}-label`;

					return (
						<ListItem
							key={value.key}
							role="listitem"
							button
							onClick={handleToggle2(value)}
						>
							<ListItemIcon>
								<Checkbox
									checked={checked.indexOf(value) !== -1}
									tabIndex={-1}
									disableRipple
									inputProps={{ "aria-labelledby": labelId }}
								/>
							</ListItemIcon>
							<ListItemText
								id={labelId}
								primary={`Employee  ${value.firstname + " " + value.lastname}`}
							/>
						</ListItem>
					);
				})}
				<ListItem />
			</List>
		</Paper>
	);

	const customList = (items) => (
		<Paper className={classes.paper}>
			<List dense component="div" role="list">
				{items.map((value) => {
					const labelId = `transfer-list-item-${value.key}-label`;

					return (
						<ListItem
							key={value.key}
							role="listitem"
							button
							onClick={handleToggle(value)}
						>
							<ListItemIcon>
								<Checkbox
									checked={checked.indexOf(value) !== -1}
									tabIndex={-1}
									disableRipple
									inputProps={{ "aria-labelledby": labelId }}
								/>
							</ListItemIcon>
							<ListItemText
								id={labelId}
								primary={`Employee  ${value.firstname + " " + value.lastname}`}
							/>
						</ListItem>
					);
				})}
				<ListItem />
			</List>
		</Paper>
	);

	const dispatch = useDispatch();
	let match = useRouteMatch();

	const [value, setValue] = React.useState("1");

	const [users, setUser] = React.useState(
		allUser
			.map((x) => ({
				title: x.username,
				id: x._id,
			}))
			.filter((x) => x.title !== null)
	);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	//start get docs
	{
	}
	//end of docs
	var buffer;
	let image;
	try {
		buffer = Buffer.from(store.getState().auth.user.image.data);
		image = "data:image/png;base64," + buffer.toString("base64");
	} catch (e) { }
	//document.getElementById("profilePicture").src ="data:image/png;base64," + buffer.toString("base64");
	const [showscreen, setShowscreen] = React.useState();
	const [imageSrc, setImageSrc] = React.useState(image);
	let imageltvar;
	try {
		imageltvar = store
			.getState()
			.auth.user.allUser.find(
				(y) => y._id === store.getState().auth.user.usernameId
			).username;
	} catch (e) { }
	const [imageAlt, setImageAlt] = React.useState(imageltvar);
	const [username, setUsername] = React.useState(imageltvar);
	const [office_name, setOffice_name] = React.useState(imageltvar);
	const [screen, setScreen] = React.useState();
	const notificationRef = useRef(null);
	const [notification, setNotification] = React.useState([]);
	const [userValueFx, setUserValueFx] = React.useState("");
	const token = localStorage.getItem("token");
	const [travellerMaster, setTravellerMaster] = React.useState([]);
	const [gotoBooking, setGotoBooking] = React.useState(false);
	const [loading, setLoading] = React.useState(false);

	let item = [];
	const setNotificationFx = async (data) => {
		console.log("setNotificationFx in TopToolBar Data=", data);
		item = [];
		let photo = {};
		const config = {
			headers: {
				"x-auth-token": token,
				"content-type": "application/json",
			},
		};
		data.NotificationResp.docs.map(async (x, index) => {
			let username = state.auth.user.allUser.find(
				(y) => y._id === x.receiverUsernameId
			).username;
			let output = await axios.get(
				IP.nodeServer + "api/profileimage/" + username,
				config
			);
			//.get(IP.nodeServer + "api/profileimage/olivier.komeza", config);
			console.log("return output=", output);
			if (output) {
				try {
					var buffer = Buffer.from(output.data.image.picture.data).toString(
						"base64"
					);
					photo = "data:image/png;base64," + buffer.toString(buffer);
				} catch (e) {
					photo = "person.png";
				}
				item.push({
					key: x._id,
					id: x.docId,
					createDate: x.createDate,
					readstatus: x.readstatus,
					readstatusDate: x.readstatusDate,
					username: username,
					message: x.message,
					photo: photo,
				});
				//if (item.length===index)
				console.log("index =", index);
				console.log("item =", item.length);
				if (index === item.length) {
					//notificationRef.current.putItems(item);
					setNotification(item);
					console.log("TopToolBar item=", item);
				}
			}
		});
	};
	const setnewProfilePicture = (value) => {
		if (value) {
			console.log("DocumentScreen USEEffect setnewProfilePicture issued");
			var buffer = Buffer.from(store.getState().userStatus.image.data);
			setImageSrc("data:image/png;base64," + buffer.toString("base64"));
		}
	};

	useEffect(() => {
		try {
			if (state.employeeBioDataMaster.data.data.employeeInfo)
				console.log(
					"state.employeeBioDataMaster.data.data.employeeInfo=",
					state.employeeBioDataMaster.data.data.employeeInfo
				);
			let travellerMasterv = [];
			travellerMasterv = travellerMaster;
			console.log(
				"travellerMasterv.filter((x) =>	x.wbid === state.employeeBioDataMaster.data.data.employeeInfo.wbid)=",
				travellerMasterv.filter(
					(x) =>
						x.wbid === state.employeeBioDataMaster.data.data.employeeInfo.wbid
				)
			);
			if (
				travellerMasterv.filter(
					(x) =>
						x.wbid === state.employeeBioDataMaster.data.data.employeeInfo.wbid
				).length === 0 &&
				left.filter(
					(x) =>
						x.key === state.employeeBioDataMaster.data.data.employeeInfo.wbid
				).length === 0 &&
				right.filter(
					(x) =>
						x.key === state.employeeBioDataMaster.data.data.employeeInfo.wbid
				).length === 0
			) {
				travellerMasterv.push({
					...state.employeeBioDataMaster.data.data.employeeInfo,
					key: state.employeeBioDataMaster.data.data.employeeInfo.wbid,
				});

				setTravellerMaster(travellerMasterv);
				setLeft(not(travellerMasterv, right));
			}
		} catch (e) { }
		if (state.employeeBioDataMaster.saved) {
			setLoading(false);
		}
	}, [state.employeeBioDataMaster.saved]);

	useEffect(() => {
		try {
			console.log("DocumentScreen props.state=", props.state);
			//props.resetDocForm();

			let actingOffices = {};
			try {
				actingOffices = props.state.userStatus.status.actingOffice
					.filter((x) => new Date(x.toDate) >= new Date() && !x.cancelled)
					.map((x) => x.officeActingOnBehalf);
				console.log("DashboardScreen real actingOffices=", actingOffices);
			} catch (e) { }

			let inputs = {
				url: IP.nodeServer + "api/getEmployeeTravelRecord",
				method: "POST",
				data: [{ name: "username", value: state.userStatus.status.username }],
			};

			props.getEmployeeTravelData(inputs);
			if (!showscreen)
				setShowscreen(<EmployeeTravelProcessingScreen showSearch={true} />);
			console.log("StaffTravelScreen USEEffect ");
		} catch (e) {
			console.log("StaffTravelScreen Error=", e);
		}
	}, [showscreen, setShowscreen]);

	React.useEffect(() => {
		if (userValueFx.title) {
			let inputs = {
				url: IP.nodeServer + "api/getEmployeeBioData",
				method: "POST",
				data: [
					{
						name: "username",
						value: userValueFx.title,
					},
				],
			};
			console.log("useEffect userValueFx=", userValueFx);

			store.dispatch(loadBioDataMaster(inputs));
		}
	}, [userValueFx, setUserValueFx]);

	const handleBookingButton = () => {
		setGotoBooking(checked2.length > 0 ? true : false);
		console.log("handleBookingButton clicked");
		let newTravel = right;
		console.log("handleBookingButton checked2=", checked2);

		console.log("handleBookingButton checked newTravel=", newTravel);
		let inputs = {
			url: IP.nodeServer + "api/getTravelLink",
			method: "POST",
			data: checked2,
			opMode: "duty",
			username: store.getState().userStatus.status.username,
		};

		console.log("handleBookingButton inputs=", inputs);
		console.log(
			"handleBookingButton state.employeeBioDataMaster=",
			state.employeeBioDataMaster
		);

		store.dispatch(loadTravelLinkData(inputs));
	};
	const clearSelection = () => {
		setRight([]);
		setLeft([]);
		setChecked([]);
		setChecked2([]);
		setTravellerMaster([]);

		leftChecked = [];
		rightChecked = [];
		setUserValueFx("");
	};
	useEffect(() => {
		if (state.employeeTravelLink.saved && gotoBooking) {
			console.log(
				"props.state.employeeTravelLink =",
				state.employeeTravelLink.data
			);

			console.log(
				"employeeTravelRequest parseString =",
				state.employeeTravelLink.data.data["SOAP-ENV:Envelope"][
				"SOAP-ENV:Body"
				]["MyIdTravelLoginResponse"]["ns2:url"]
			);
			window.open(
				state.employeeTravelLink.data.data["SOAP-ENV:Envelope"][
					"SOAP-ENV:Body"
				]["MyIdTravelLoginResponse"]["ns2:url"]
					? state.employeeTravelLink.data.data["SOAP-ENV:Envelope"][
					"SOAP-ENV:Body"
					]["MyIdTravelLoginResponse"]["ns2:url"]
					: state.employeeTravelLink.data.data["SOAP-ENV:Envelope"][
					"SOAP-ENV:Body"
					]["MyIdTravelLoginResponse"]["ns2:url"]["_"],
				"_blank"
			);
			/*window.location.href =
				props.props.state.employeeTravelLink.data.data["SOAP-ENV:Envelope"][
					"SOAP-ENV:Body"
				]["MyIdTravelLoginResponse"]["ns2:url"]["_"];
				*/
		}
	}, [state.employeeTravelLink.saved]);

	console.log("travellerMaster=", travellerMaster);
	if (!state.userStatus.status) return <div>Loading</div>;

	return (
		<div className="container">
			<LeftSideScreen
				//openEditing={openEditing}
				//openAllDocs={openAllDocs}
				//showDocumentTable={showDocumentTable}
				imageSrc={imageSrc}
				imageAlt={imageAlt}
				office_name={office_name}
				username={username}
				setnewProfilePicture={setnewProfilePicture}
			/>

			<section id="contents">
				<PrimarySearchAppBar ref={notitifcationRef} item={notification} />
				<Switch>
					<Route path={`${match.path}/add`}>
						<AddNewtravel props={props} />
					</Route>
					<Route path={match.path}>
						<div className={classes.root}>
							<TabContext value={value}>
								<AppBar position="static">
									{state.userStatus.isInitialized ? (
										state.userStatus.status.roles.filter((x) =>
											["ADMIN", "DUTY_MNG"].includes(x.role)
										).length > 0 && (
											<TabList
												onChange={handleChange}
												aria-label="simple tabs example"
											>
												<Tab label="leisure Travel" value="1" />
												<Tab label="Duty Travel" value="2" />
											</TabList>
										)
									) : (
										<TabList
											onChange={handleChange}
											aria-label="simple tabs example"
										>
											<Tab label="leisure Travel" value="1" />
										</TabList>
									)}
								</AppBar>
								<TabPanel value="1">
									{showscreen}
									<Link to={`${match.path}/add`}>
										<Fab
											color="primary"
											aria-label="add"
											className={classes.fab}
										>
											<AddIcon />
										</Fab>
									</Link>
								</TabPanel>
								{state.userStatus.isInitialized
									? state.userStatus.status.roles.filter((x) =>
										["ADMIN", "DUTY_MNG"].includes(x.role)
									).length > 0 && (
										<TabPanel value="2">
											<SelectionCombo
												ref={refUserSelect}
												title="Select staff to travel"
												options={users}
												onChange={(value) =>
													console.log(
														"StaffTravelScreen onChange value=",
														value
													)
												}
												setUserTitleValue={(value) => {
													console.log(
														"setUserTitleValue Select who fo travel you value=",
														value
													);
													try {
														if (value.title !== null) {
															setLoading(true);
															setUserValueFx(value);
														}
													} catch (e) {
														setUserValueFx("");
													}
												}}
											/>
											{loading && <div>Loading...</div>}

											{left.length > 0 || right.length > 0 ? (
												<Button onClick={clearSelection}>
													{" "}
													Clear Selection <ClearIcon />{" "}
												</Button>
											) : (
												""
											)}

											<Grid
												container
												spacing={2}
												justify="center"
												alignItems="center"
												className={classes.root}
											>
												<Grid item>{customList(left)}</Grid>
												<Grid item>
													<Grid
														container
														direction="column"
														alignItems="center"
													>
														<Button
															variant="outlined"
															size="small"
															className={classes.button}
															onClick={handleAllRight}
															disabled={left.length === 0}
															aria-label="move all right"
														>
															≫
														</Button>
														<Button
															variant="outlined"
															size="small"
															className={classes.button}
															onClick={handleCheckedRight}
															disabled={leftChecked.length === 0}
															aria-label="move selected right"
														>
															&gt;
														</Button>
														<Button
															variant="outlined"
															size="small"
															className={classes.button}
															onClick={handleCheckedLeft}
															disabled={rightChecked.length === 0}
															aria-label="move selected left"
														>
															&lt;
														</Button>
														<Button
															variant="outlined"
															size="small"
															className={classes.button}
															onClick={handleAllLeft}
															disabled={right.length === 0}
															aria-label="move all left"
														>
															≪
														</Button>
													</Grid>
												</Grid>
												<Grid item>
													{customList2(right)}
													{checked2.length > 0 ? (
														<Button
															variant="contained"
															color="primary"
															loading={state.employeeTravelLink.isLoading}
															disabled={state.employeeTravelLink.isLoading}
															onClick={handleBookingButton}
														>
															{state.employeeTravelLink.isLoading ? <CircularProgress size={22} /> : "GO to Booking"}
														</Button>
													) : (
														""
													)}
												</Grid>
											</Grid>
										</TabPanel>
									)
									: ""}
							</TabContext>
						</div>
					</Route>
				</Switch>
			</section>
		</div>
	);
}

function AddNewtravel(props) {
	const classes = useStyles();
	const [checked, setChecked] = React.useState([]);
	const [checked2, setChecked2] = React.useState([]);
	const [gotoBooking, setGotoBooking] = React.useState(false);
	const state = useSelector((state) => state);

	const handleToggle = (value) => () => {
		const currentIndex = checked.indexOf(value);
		const newChecked = [...checked];

		if (currentIndex === -1) {
			newChecked.push(value);
		} else {
			if (currentIndex !== 0) newChecked.splice(currentIndex, 1);
		}

		setChecked(newChecked);
	};
	let traveller = [];
	try {
		console.log(
			"AddNewtravel store.getState()=",
			store.getState().employeeBioData.data.data.employeeInfo
		);
		if (store.getState().employeeBioData.data.data.employeeInfo)
			traveller.push(store.getState().employeeBioData.data.data.employeeInfo);

		console.log("traveller=", traveller);
	} catch (e) { }
	try {
		console.log(
			"AddNewtravel store.getState()=",
			store.getState().employeeBioData.data.data.dependentInfo
		);
		store.getState().employeeBioData.data.data.dependentInfo.map((x) => {
			traveller.push(x);
		});
		console.log("traveller=", traveller);
	} catch (e) { }
	traveller = traveller.map((x, index) => ({ ...x, key: index }));
	//setChecked([0, 1, 2, 3]);

	let listitem = traveller.map((x, index) => {
		const labelId = `checkbox-list-secondary-label-${x.firstname + " " + x.lastname
			}`;

		return (
			<ListItem key={index} button>
				<ListItemAvatar>
					<Avatar alt={`Avatar n°${x.lastname}`} />
				</ListItemAvatar>

				<ListItemText
					id={labelId}
					primary={` ${(x.salutation ? x.salutation + " " : "") +
						x.firstname +
						" " +
						x.lastname
						}`}
				/>
				<ListItemText id={labelId} secondary={`DOB:  ${x.dob}`} />
				<ListItemText
					id={labelId}
					secondary={`is ${x.wbid ? "Employee" : "Dependent"}`}
				/>
				<ListItemSecondaryAction>
					<Checkbox
						edge="end"
						onChange={handleToggle(index)}
						checked={checked.indexOf(index) !== -1}
						inputProps={{ "aria-labelledby": labelId }}
					/>
				</ListItemSecondaryAction>
			</ListItem>
		);
	});
	const handleBookingButton = () => {
		setGotoBooking(true);
		console.log("handleBookingButton clicked");
		console.log("handleBookingButton traveller=", traveller);
		console.log("handleBookingButton checked2=", checked2);
		let is_senior = false;
		try {
			is_senior = state.officeData.allOffice.find(
				(x) =>
					x.office_id === state.auth.user.office[0].office_id &&
					x.companyId === state.companyData.selectedCompanyId
			).is_senior;
		} catch (e) { }
		let newTravel = traveller;

		newTravel = traveller
			.filter((y) => y.wbid)
			.map((x) => ({ ...x, is_senior: is_senior ? is_senior : false }));
		newTravel = newTravel.concat(
			traveller.filter((y) => checked.includes(y.key) && !y.wbid)
		);

		console.log("handleBookingButton checked=", traveller);
		console.log("handleBookingButton checked newTravel=", newTravel);
		//state.auth.user.office[0].office_id
		let inputs = {
			url: IP.nodeServer + "api/getTravelLink",
			method: "POST",
			data: newTravel,
			opMode: "leisure",
			username: store.getState().userStatus.status.username,
		};
		console.log("handleBookingButton inputs=", inputs);
		console.log(
			"handleBookingButton state.employeeBioDataMaster=",
			state.employeeBioDataMaster
		);

		store.dispatch(loadTravelLinkData(inputs));
	};

	console.log("StaffTravel checked traveller=", traveller);
	console.log("props", props.props.state.employeeTravelLink);
	useEffect(() => {
		if (props.props.state.employeeTravelLink.saved && gotoBooking) {
			console.log(
				"props.state.employeeTravelLink =",
				props.props.state.employeeTravelLink.data
			);

			console.log(
				"employeeTravelRequest parseString =",
				props.props.state.employeeTravelLink.data.data["SOAP-ENV:Envelope"][
				"SOAP-ENV:Body"
				]["MyIdTravelLoginResponse"]["ns2:url"]["_"]
			);
			console.log(
				"employeeTravelRequest parseString changed =",
				props.props.state.employeeTravelLink.data.data["SOAP-ENV:Envelope"][
				"SOAP-ENV:Body"
				]["MyIdTravelLoginResponse"]["ns2:url"]
			);
			window.open(
				props.props.state.employeeTravelLink.data.data["SOAP-ENV:Envelope"][
				"SOAP-ENV:Body"
				]["MyIdTravelLoginResponse"]["ns2:url"],
				"_blank"
			);
			/*window.location.href =
				props.props.state.employeeTravelLink.data.data["SOAP-ENV:Envelope"][
					"SOAP-ENV:Body"
				]["MyIdTravelLoginResponse"]["ns2:url"]["_"];
				*/
		}
	}, [props.props.state.employeeTravelLink.saved]);

	return (
		<Box color="text.primary">
			<Link to="/StaffTravel">
				<ArrowBackIosIcon style={{ color: green[500] }} />
			</Link>
			{state.employeeBioDataMaster.isLoading ? <CircularProgress /> :
				<>
					<font color="white">Please select who to book flight</font>
					<List dense className={classes.root}>
						{listitem}
					</List>
				</>}
			{checked.length > 0 ? (
				<Button
					variant="contained"
					color="primary"
					onClick={handleBookingButton}
				>
					GO to Booking
				</Button>
			) : (
				""
			)}
		</Box>
	);
}

const mapDispatchToProps = (dispatch) => ({
	getEmployeeTravelData: (data) => dispatch(getEmployeeTravelData(data)),
	loadTravelLinkData: (data) => dispatch(loadTravelLinkData(data)),
});
const mapStateToProps = (state) => ({ state });
//connect(mapStateToProps, mapDispatchToProps)(AddNewtravel);

export default connect(mapStateToProps, mapDispatchToProps)(StaffTravelScreen);
